
const pad = (num, charCnt = 2, fillChar = '0') => {
	const fillCharStr = (new Array((charCnt - num.toString().length) + 1)).join(fillChar);
	return `${fillCharStr}${num}`;
};

const maskMap = {
	yyyy: d => d.getFullYear(),
	yy: d => d.getFullYear().toString().slice(-2),
	mm: d => pad(d.getMonth() + 1),
	m: d => d.getMonth() + 1,
	dd: d => pad(d.getDate()),
	d: d => d.getDate(),
	hh: d => pad(d.getHours()),
	h: d => d.getHours(),
	MM: d => pad(d.getMinutes()),
	M: d => d.getMinutes(),
	ss: d => pad(d.getSeconds()),
	s: d => d.getSeconds(),
	i: d => d.getMilliseconds(),
	tt: d => pad(Math.abs(d.getTimezoneOffset() / 60)),
	t: d => Math.abs(d.getTimezoneOffset() / 60),
};

const format = (formatStr, dateObj = new Date()) => {
	let formatStrReplacement = formatStr;

	Object.keys(maskMap).forEach((mask) => {
		const maskRegExp = new RegExp(`${mask}`, 'g');
		if (maskMap[mask] && formatStrReplacement.match(maskRegExp)) {
			formatStrReplacement = formatStrReplacement.replace(maskRegExp, maskMap[mask](dateObj));
		}
	});

	return formatStrReplacement;
};


export default { format };



// WEBPACK FOOTER //
// ./src/helper/dateHelper.js